import Head from "next/head";
import HummingFooter from "pages/components/HummingFooter";
import HummingNav from "pages/components/HummingNav";
import React, { useEffect } from "react";
import { ExtendedNextPage } from "types/pages";
import Heading from "./components/Heading";
import HowItWorks from "./components/HowItWorks";
import NeonHomeCounter from "./components/NeonHomeCounter";
import Reviews from "./components/Reviews";
import ShareLink from "./components/ShareLink";

import styles from "./styles.module.scss";

const Refer: ExtendedNextPage = () => {
  useEffect(() => {
    window?.growsurf?.init?.();
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>Refer A Friend | Give 1 month free, receive $1000</title>
        <meta
          name="description"
          content="Refer a friend and give one month of the Humming Homes subscription, free. Receive $1,000 for each successful referral."
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/refer" />
      </Head>
      <Heading />
      <HowItWorks />
      <NeonHomeCounter />
      <Reviews />
      <ShareLink />
    </div>
  );
};

Refer.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Refer;
